import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MatDialogRef } from '@angular/material/dialog';
import { CategoryModel } from 'src/app/models/ClassificationModel';
import { ClassificationCService } from 'src/app/services/ClassificationCService';

@Component({
  selector: 'app-cont-category-search',
  templateUrl: './cont-category-search.component.html',
  styleUrls: ['./cont-category-search.component.css']
})
export class ContCategorySearchComponent implements OnInit {
  catCode ='' ;
  catName ='' ;
  catNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';

  ContCategoryList : CategoryModel[]=[];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<ContCategorySearchComponent>,
              public contcategoryservice: ClassificationCService,
              public contcategorySelectedData : CategoryModel,
  ) { }

  ngOnInit(): void {
    this.retriveDoctorsLookupTop();
  }
  retriveDoctorsLookup(){

  }
  retriveDoctorsLookupTop(){
    this.ContCategoryList = [];
    this.contcategoryservice.getCategoryLookupTop().subscribe((data: CategoryModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContCategoryList[i] = data[i];
      }
    })
  }

  SelectContCategory(Do : CategoryModel){
    this.contcategorySelectedData.catCode = Do.catCode
    this.contcategorySelectedData.catName = Do.catName
    this.contcategorySelectedData.catNotes = Do.catNotes


    this.contcategorySelectedData.userID = Do.userID
    this.contcategorySelectedData.modifaiedDate = Do.modifaiedDate
    this.contcategorySelectedData.compCode = Do.compCode
    this.submitClicked.emit(this.contcategorySelectedData);
    this.dialogRef.close();

  }
}
